import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface Inputs {
  companyId: string
}

interface HookProps {
	onSuccess?: (filepath: string) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useMemberReport = ({
	onSuccess,
  onError
}: HookProps) => {
  const {
		mutate: onGenerateMemberReport,
		...rest
	} = useMutation({
		mutationFn: async ({ companyId }: Inputs) => {
			const { data: { filename } } = await axios.get(`/reports/company-recipients/${companyId}`)
      return filename;
		},
		onSuccess,
    onError
	});

	return { onGenerateMemberReport, ...rest };
};
